import React, { FC } from 'react'

import { VehicleIdToIcon } from '../../constants/vehicleTypes.consts'
import { Vehicle } from '../../types/vehicle.interface'
import {
    Wrapper,
    CardBody,
    CarIcon,
    RightIcon,
    BodyWrapper,
    FlexContainer,
    PlateText,
    IconsContainer
} from './VehicleCard.style'

interface Props {
    vehicle: Vehicle
    onVehicleClick: (vehicle: Vehicle) => void
}

const VehicleCard: FC<Props> = ({ vehicle, onVehicleClick }) => {
    const getCarIcon = () => {
        const { vehicle_type } = vehicle
        if (!vehicle_type) return 'wemolo-car-medium'

        return VehicleIdToIcon(vehicle_type)
    }

    return (
        <Wrapper>
            <CardBody>
                <BodyWrapper
                    onClick={() => {
                        onVehicleClick(vehicle)
                    }}
                >
                    <CarIcon className={getCarIcon()} />
                    <FlexContainer>
                        <PlateText>{vehicle.plate}</PlateText>
                        <span>{vehicle.name}</span>
                    </FlexContainer>
                </BodyWrapper>
                <IconsContainer>
                    <RightIcon className="wemolo-edit minor-hover-effect" onClick={() => onVehicleClick(vehicle)} />
                </IconsContainer>
            </CardBody>
        </Wrapper>
    )
}

export default VehicleCard
